<div class="content">
    <div class="result-card">
        <h1 class="result-header">
            Your transaction was successful!
        </h1>
        @switch(state()){
            @case ('upgraded'){
                <p class="result-text text-upgraded">
                    Your transaction has been processed and your account has been upgraded. You can now benefits from hundreds of discounts on our app!
                </p>
                <mat-divider></mat-divider>
                <div class="continue f-cross-center cgap-6">
                    <a mat-stroked-button [routerLink]="['/']">
                        CONTINUE BROWSING
                    </a>
                    <a mat-flat-button class="premium-horizontal" [routerLink]="['/get-the-app']">
                        GET THE APP
                    </a>
                </div>
            }

            @default {
                <p class="result-text text-pending">
                    Your transaction has been processed and your account will be upgraded shortly.
                </p>
                <mat-divider></mat-divider>
                <div class="account-status">
                    <p class="font-light m-0">
                        Current Status:
                        <span class="font-bold">Pending</span>
                    </p>
                    <button mat-flat-button (click)="retry()" [disabled]="on_cooldown()">
                        <mat-icon iconPositionStart [class.rotating]="on_cooldown()">autorenew</mat-icon>
                        <span>
                            Recheck
                        </span>
                    </button>
                </div>
                @if(attempts() > 2){
                    <p paint="warn" class="m-0 disclaimer">If your account is not being upgraded, please contact us on support&#64;cloudigo.app or Messenger.</p>
                }
            }
        }
    </div>
</div>
